import Entity from '../types/Entity'

const compareOrder = (a: Entity, b: Entity) => {
  if (a.order !== null && b.order !== null) {
    if (a.order < b.order) {
      return -1
    }

    if (a.order > b.order) {
      return 1
    }
  }
  return 0
}

export default compareOrder
